import { createReducer } from '../../app/common/util/reducerUtil';
import { VERFIY_TWO_FA_LOGIN, CHANGE_RESEND_STATUS } from './twoFAconstants';

const initialState = {
  showResend: false,
};

export const verifyTwoFALogin = (state, payload) => {
  return {
    ...state,
    login: payload,
  };
};

export const changeResendStatus = (state, payload) => {
  return {
    ...state,
    showResend: payload.showResend,
  }
}

export default createReducer(initialState, {
  [VERFIY_TWO_FA_LOGIN]: verifyTwoFALogin,
  [CHANGE_RESEND_STATUS]: changeResendStatus,
});